var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.336C14.5 24.732 14.235 24.157 13.762 23.782C13.039 23.208 11.785 22.5 10 22.5C8.215 22.5 6.961 23.208 6.238 23.782C5.765 24.157 5.5 24.732 5.5 25.336V26.5H14.5V25.336Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C11.3807 19.5 12.5 18.3807 12.5 17C12.5 15.6193 11.3807 14.5 10 14.5C8.61929 14.5 7.5 15.6193 7.5 17C7.5 18.3807 8.61929 19.5 10 19.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 25.336C27.5 24.732 27.235 24.157 26.762 23.782C26.039 23.208 24.785 22.5 23 22.5C21.215 22.5 19.961 23.208 19.238 23.782C18.765 24.157 18.5 24.732 18.5 25.336V26.5H27.5V25.336Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.5C24.3807 19.5 25.5 18.3807 25.5 17C25.5 15.6193 24.3807 14.5 23 14.5C21.6193 14.5 20.5 15.6193 20.5 17C20.5 18.3807 21.6193 19.5 23 19.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3027 9.5503L17.4483 9.26814L18.1436 7.92021C18.1651 7.87729 18.1732 7.83325 18.1701 7.79104C18.1668 7.74832 18.1517 7.70341 18.1216 7.66062C18.0912 7.61735 18.0457 7.57682 17.9857 7.54695C17.9254 7.51696 17.8551 7.50001 17.7816 7.5L17.3027 9.5503ZM17.3027 9.5503L17.4962 9.80204M17.3027 9.5503L17.4962 9.80204M17.4962 9.80204L18.472 11.0718C18.4918 11.1106 18.5006 11.1508 18.5 11.1894C18.4993 11.2336 18.486 11.2801 18.4571 11.3247C18.4278 11.3698 18.3824 11.4127 18.321 11.4446C18.2595 11.4766 18.1867 11.4948 18.1104 11.4949H16.3929H16.2313M17.4962 9.80204L16.2313 11.4949M16.2313 11.4949L16.1003 11.5894M16.2313 11.4949L16.1003 11.5894M16.1003 11.5894L15.5 12.0226V7.8088C15.5 7.80878 15.5 7.80875 15.5 7.80873C15.5 7.74301 15.5283 7.66919 15.5969 7.60685C15.6671 7.543 15.7716 7.50002 15.8892 7.5M16.1003 11.5894L15.8892 7.5M15.8893 7.5H17.7815H15.8893ZM15.8893 7.5C15.8893 7.5 15.8892 7.5 15.8892 7.5M15.8893 7.5H15.8892"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUser);
export default __webpack_public_path__ + "static/media/InviteUser.d191213559e8c77666f39433d8b6ed42.svg";
export { ForwardRef as ReactComponent };